import { PageWrapper } from "@components/page-wrapper"
import { Stack, Typography, Button } from "@mui/material"
import { useRouteError, useNavigate } from "react-router-dom"

export default function PageNotFound() {
  const error = useRouteError()
  const navigate = useNavigate()
  console.warn("error", error)

  return (
    <PageWrapper>
      <Stack spacing={3} alignItems="center" sx={{ mt: 10 }}>
        <Typography align="center" variant="h2" color="primary">
          Oops!
        </Typography>
        <Typography align="center" variant="h3">
          That page was not found!
        </Typography>
        <Typography align="center">
          Sorry, it's either that page does not exist or you're not authorised
          to visit the page
        </Typography>
        <Button
          variant="contained"
          onClick={() => {
            navigate("/")
          }}
        >
          Let's go back home
        </Button>
      </Stack>
    </PageWrapper>
  )
}
